import "core-js/modules/es6.array.find";
import "core-js/modules/es6.function.name";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
export default {
  name: "opv",
  props: ["opvData", "deviceSoftwareVer"],
  data: function data() {
    return {
      opvDialog: false,
      more: "",
      moreList: ["nice", "dev_type", "server", "server_bridge", "compress"],
      moreListObj: {
        nice: this.$t('lang.openvpn.nice'),
        dev_type: this.$t('lang.openvpn.dev_type'),
        server: this.$t('lang.openvpn.server'),
        server_bridge: this.$t('lang.openvpn.server_bridge'),
        compress: this.$t('lang.openvpn.compress'),
        auth: this.$t('lang.openvpn.auth'),
        tls_crypt: this.$t('lang.openvpn.tls_crypt')
      },
      showList: [],
      content: {
        ca: {
          file_name: "/etc/luci-uploads/cbid.openvpn.opv1.ca",
          content: ""
        },
        key: {
          file_name: "/etc/luci-uploads/cbid.openvpn.opv1.key",
          content: ""
        },
        cert: {
          file_name: "/etc/luci-uploads/cbid.openvpn.opv1.cert",
          content: ""
        },
        secret: {
          file_name: "/etc/luci-uploads/cbid.openvpn.opv1.secret",
          content: ""
        },
        pkcs12: {
          file_name: "/etc/luci-uploads/cbid.openvpn.opv1.pkcs12",
          content: ""
        },
        dh: {
          file_name: "/etc/luci-uploads/cbid.openvpn.opv1.dh",
          content: ""
        },
        tls_crypt: {
          file_name: "/etc/luci-uploads/cbid.openvpn.opv1.tls_crypt",
          content: ""
        }
      },
      fileNameList: {
        ca: {
          file_name: ""
        },
        key: {
          file_name: ""
        },
        cert: {
          file_name: ""
        },
        secret: {
          file_name: ""
        },
        pkcs12: {
          file_name: ""
        },
        dh: {
          file_name: ""
        },
        tls_crypt: {
          file_name: ""
        }
      },
      rules: {
        port: [{
          required: true,
          message: "请输入端口",
          trigger: "blur"
        }],
        cipher: [{
          required: true,
          message: "请输入加密数据包",
          trigger: "blur"
        }],
        keepalive: [{
          required: true,
          message: "请输入值",
          trigger: "blur"
        }]
      },
      authList: [{
        label: "---移除---",
        value: ""
      }, {
        label: "SHA256",
        value: "SHA256"
      }, {
        label: "---自定义---",
        value: "custom"
      }],
      secretShow: false,
      authInputShow: false,
      authValue: "",
      tlsAuthShow: false,
      usdDhShow: false,
      usePkcsShow: false,
      useTlsCryptShow: false
    };
  },
  methods: {
    removeRemote: function removeRemote(e) {
      this.opvData.remote = this.opvData.remote.filter(function (v, index) {
        return index != e;
      });
    },
    fileUpdate: function fileUpdate(e, name) {
      var _this = this;

      var file = e.target.files[0];
      var txt = new FileReader();
      txt.readAsText(file, "UTF-8");

      txt.onload = function () {
        _this.content[name].content = txt.result;
        _this.fileNameList[name].file_name = file.name;

        _this.$message({
          message: "本地文件上传成功",
          type: "success"
        });
      };
    },
    confirm: function confirm() {
      this.opvDialog = false;
      this.$emit("update", this.content, this.opvData);
    },
    addRemote: function addRemote() {
      if (this.opvData.remote[this.opvData.remote.length - 1]) {
        this.opvData.remote.push("");
      }
    },
    addOptions: function addOptions() {
      var _this2 = this;

      this.moreList = this.moreList.filter(function (v) {
        return v != _this2.more;
      });
      this.showList.push(this.more);
      this.more = "";
    },
    inputChange: function inputChange(e) {
      console.log(this.opvData.remote[e]);
    },
    changeUseStaticKey: function changeUseStaticKey() {
      this.secretShow = !this.secretShow;
    },
    authChange: function authChange() {
      if (this.opvData.auth == "custom") {
        this.authValue = "";
        this.authInputShow = true;
      }
    },
    changeAuthValue: function changeAuthValue() {
      var _this3 = this;

      if (this.authList.find(function (v) {
        return v.label == _this3.authValue;
      })) {
        this.opvData.auth = this.authValue;
        this.authInputShow = false;
      } else {
        this.authList.push({
          label: this.authValue,
          value: this.authValue
        });
        this.opvData.auth = this.authValue;
        this.authInputShow = false;
      }
    },
    changeUseTlsAuth: function changeUseTlsAuth() {
      this.tlsAuthShow = !this.tlsAuthShow;
    },
    changeUseDh: function changeUseDh() {
      this.usdDhShow = !this.usdDhShow;
    },
    changeUsePkcs: function changeUsePkcs() {
      this.usePkcsShow = !this.usePkcsShow;
    },
    changeUseTlsCrypt: function changeUseTlsCrypt() {
      this.useTlsCryptShow = !this.useTlsCryptShow;
    }
  },
  created: function created() {
    if (this.deviceSoftwareVer >= "v2.5.221125") {
      this.moreList.push("auth");
      this.moreList.push("tls_crypt");
      this.moreList.push("dh");
      this.moreList.push("pkcs12");
    }
  }
};